import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";

const SHOWCASE_ITEMS = [
  { img: ASSETS.maleCable, label: "Intelligent Intake", sub: "AI-Powered Documentation" },
  { img: ASSETS.womenSquat, label: "Multi-Domain Analysis", sub: "Integrated Matrix Engine" },
  { img: ASSETS.coupleTraining, label: "Protocol Automation", sub: "Standardized Care Workflows" },
];

export const ImageShowcase = () => (
  <div className="py-16 px-6 lg:px-12 relative z-[1]" data-testid="image-showcase">
    <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
      {SHOWCASE_ITEMS.map((item, i) => (
        <motion.div
          key={i}
          className="img-showcase-card rounded-lg"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: i * 0.15 }}
        >
          <img src={item.img} alt={item.label} />
          <div className="absolute bottom-6 left-6 z-[2]">
            <div className="font-orbitron text-base lg:text-lg font-bold tracking-[3px] text-white uppercase text-shadow">
              {item.label}
            </div>
            <div className="font-outfit text-sm lg:text-base text-white/60 tracking-[1px] text-shadow-sm mt-1">
              {item.sub}
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  </div>
);
